import { Link } from "react-router-dom";
import { BiLike } from "react-icons/bi";
import { FaHeart, FaStar } from "react-icons/fa";
import { BsCheckCircle } from "react-icons/bs";
import styles from "./ServicesAccordionTable.module.css";
import { localePath } from "../../i18n/config";

const ServicesAccordionTable = () => {
  return (
    <div className={styles.container}>

      <div className={styles.cardsWrapper}>
        {/* HUOLETON */}
        <div className={styles.card}>
          <div className={styles.header}>
            HUOLETON <BiLike />
          </div>

          <div className={styles.subtitle}>
            Pieni tabletti 8,7" lähinnä videopuheluihin. Edullisin!
          </div>

          <ul className={styles.list}>
            <li>Samsung Galaxy Tab A9 tai A11 LTE</li>
            <li>Liittymä, jalusta</li>
            <li>Valmiiksi asennettu, jatkuva it-tuki*</li>
            <li>41 €/kk</li>
          </ul>

          <div className={styles.sectionTitle}>
            3 vaihtoehtoa sisältöön**
          </div>

          <ul className={styles.options}>
            <li>
              <BsCheckCircle className={styles.check} />
              <span className={styles.bold}>
                Digihappy videopuhelut – oletus
              </span>
            </li>
            <li>
              <BsCheckCircle className={styles.check} />
              Digihappy videopuhelut, äänikirjat, radio
            </li>
            <li>
              <BsCheckCircle className={styles.check} />
              Digihappy videopuhelut, äänikirjat, radio,
              lääkemuistutus, YleAreena, Chrome
            </li>
          </ul>
        </div>

        {/* HELPPO */}
        <div className={styles.card}>
          <div className={styles.header}>
            HELPPO <FaHeart />
          </div>

          <div className={styles.subtitle}>
            Iso tabletti (10.5"/11") vain videopuheluihin tai myös parhaisiin
            aktiviteetteihin. <b>Suosituin!</b>
          </div>

          <ul className={styles.list}>
            <li>Samsung Galaxy Tab A9 + 5G tai A11+ 5G</li>
            <li>Liittymä, jalusta</li>
            <li>Valmiiksi asennettu, jatkuva it-tuki*</li>
            <li>49 €/kk</li>
          </ul>

          <div className={styles.sectionTitle}>
            5 vaihtoehtoa sisältöön**
          </div>

          <ul className={styles.options}>
            <li>
              <BsCheckCircle className={styles.check} />
              Digihappy videopuhelut
            </li>
            <li>
              <BsCheckCircle className={styles.check} />
              Digihappy videopuhelut, Äänikirjat, Radio
            </li>
            <li>
              <BsCheckCircle className={styles.check} />
              Digihappy videopuhelut, Äänikirjat, Radio,
              Lääkemuistutus, YleAreena, Chrome
            </li>
            <li>
              <BsCheckCircle className={styles.check} />
              <span className={styles.bold}>
                Digihappy videopuhelut, Äänikirjat, Radio,
                Lääkemuistutus, Uutiset, YleAreena, Pelit,
                Chrome – oletus
              </span>
            </li>
            <li>
              <BsCheckCircle className={styles.check} />
              Digihappy videopuhelut, Äänikirjat, Radio,
              Lääkemuistutus Uutiset, YleAreena, Pelit,
              Chrome, Taide, Spotify, WhatsApp
            </li>
          </ul>
        </div>

        {/* MESTARI */}
        <div className={styles.card}>
          <div className={styles.header}>
            MESTARI <FaStar />
          </div>

          <div className={styles.subtitle}>
            Iso tabletti (10.5"/11"), jonka räätälöimme seniorille. Lue
            yksilöllisistä ratkaisuista <b>blogistamme!</b>
          </div>

          <ul className={styles.list}>
            <li>Samsung Galaxy Tab A9 + 5G tai A11+ 5G</li>
            <li>Liittymä, jalusta</li>
            <li>Valmiiksi asennettu, jatkuva it-tuki*</li>
            <li>53 €/kk</li>
          </ul>

          <div className={styles.sectionTitle}>
            Valitse sisältö vapaasti**
          </div>

          <ul className={styles.options}>
            <li>
              <BsCheckCircle className={styles.check} />
              Valitse apit, nettisivut, myös omat tiedostot etusivulle kuvakkeena.
            </li>
            <li >
              <BsCheckCircle className={styles.check} />
             <p> Digihappy videopuhelut. Jos haluat tavalliset puhelut tabletille katso{" "}
             <Link to={localePath("senioripuhelin")} >Senioripuhelin</Link></p>
            </li>
            <li>
              <BsCheckCircle className={styles.check} />
              Muistisairaalle usein kellokalenterinäkymä, lääkemuistutus, oma kuvatiedosto
            </li>
            <li>
              <BsCheckCircle className={styles.check} />
              Aivoinfarktipotilaalle usein kuntoutusapit- puhe, motoriikka, hahmotus.
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.buttonContainer}>
        <Link to={localePath("osta", "senioritabletti")}>
          <button className={styles.button}>OSTA</button>
        </Link>
      </div>
    </div>
  );
};

export default ServicesAccordionTable;
